export type SelectOutlineSearchType = 'local' | 'service';

export enum SelectOutlineWithPanel {
  large = 'large',
  default = 'default',
}

export interface SelectOutlineOption {
  label: string;
  value: string;
}
